module.exports = __webpack_public_path__ + "img/5-leaving-home_v8e.8b9c4161.png";